
<template>
  <BreadCrumb PageTitle="Chat Room" />
  <div class="row" v-if="user">
    <div class="col-xxl-12">
      <ChatRoom />
    </div>
  </div>
</template>

<script setup>
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ChatRoom from "../../components/Admin/Chat/ChatContent.vue";

import { useAccountStore } from "@/stores"
import { storeToRefs } from 'pinia';
const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore);
</script>